import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiClient {
  private http = inject(HttpClient);
  private base = environment.apiBaseUrl;
  get<T>(path: string): Promise<T>  { return firstValueFrom(this.http.get<T>(`${this.base}${path}`)); }
  post<T>(path: string, body: unknown): Promise<T> { return firstValueFrom(this.http.post<T>(`${this.base}${path}`, body)); }
  put<T>(path: string, body: unknown): Promise<T>  { return firstValueFrom(this.http.put<T>(`${this.base}${path}`, body)); }
  delete<T>(path: string): Promise<T> { return firstValueFrom(this.http.delete<T>(`${this.base}${path}`)); }

  /**
   * Multipart upload. No Content-Type header is set on purpose — the browser
   * has to add its own, including the boundary, and a hand-written
   * `multipart/form-data` without one produces a request the server cannot
   * parse.
   */
  postForm<T>(path: string, form: FormData): Promise<T> {
    return firstValueFrom(this.http.post<T>(`${this.base}${path}`, form));
  }

  /** Downloads a file rather than JSON — the onboarding template. */
  getBlob(path: string): Promise<Blob> {
    return firstValueFrom(this.http.get(`${this.base}${path}`, { responseType: 'blob' }));
  }
}
